__turbopack_context__.v({
  "className": "quicksand_8514c1be-module__jXievq__className",
  "variable": "quicksand_8514c1be-module__jXievq__variable",
});
